import { InputField, CheckboxField } from 'components'
import { useFormikContext, FieldArray } from 'formik'
import {
  Button,
  Table
} from 'reactstrap'
import PropTypes from 'prop-types'

const defaultVoucherAttr = {
  code             : '',
  use_per_customer : 1,
  usage_limit      : 1
}
/**
 * Renders inputs for the array of codes
 * - `VoucherRule` has_many `Vouchers`
 * - `::Voucher` referes to the codes of the voucher rule
 */
const VoucherAttributesFieldArray = ({ name }) => {

  const formik = useFormikContext()

  return (
    <Table className='mb-0'>
      <thead>
        <tr>
          <th>No.</th>
          <th>ID</th>
          <th>Code</th>
          <th>Use Per Customer</th>
          <th>From Date</th>
          <th>To Date</th>
          <th>Usage Limit</th>
          <th>Times Used</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <FieldArray name={ name }>
          {
            (arrayHelpers) => (
              <>
                {
                  // ! <tr> key prop must use a value that does not change
                  // - prevents input from losing focus onChange
                  formik.values.vouchers_attributes.map((voucherCode, index) => (
                    <tr
                      className={ !voucherCode.id ? 'bg-success' : 'bg-light' }
                      key={ `voucher-attr-row-${index}` }
                    >
                      <td>
                        { index+1 }
                      </td>
                      <td>{ voucherCode?.id || '-' }</td>
                      <td>
                        <InputField
                          formGroupClassName='mb-0'
                          bsSize={ 'sm' }
                          name={ `${name}.${index}.code` }
                          type={ 'text' }
                        />
                      </td>
                      <td>
                        <InputField
                          formGroupClassName='mb-0'
                          bsSize={ 'sm' }
                          name={ `${name}.${index}.use_per_customer` }
                          type={ 'number' }
                        />
                      </td>
                      <td>
                        <InputField
                          formGroupClassName='mb-0'
                          bsSize={ 'sm' }
                          name={ `${name}.${index}.from_date` }
                          type='date'
                        />
                      </td>
                      <td>
                        <InputField
                          formGroupClassName='mb-0'
                          bsSize={ 'sm' }
                          name={ `${name}.${index}.to_date` }
                          type='date'
                        />
                      </td>
                      <td>
                        <InputField
                          formGroupClassName='mb-0'
                          bsSize={ 'sm' }
                          name={ `${name}.${index}.usage_limit` }
                          type={ 'number' }
                        />
                      </td>
                      <td>
                        { voucherCode.times_used  || '-' }
                      </td>

                      <td>
                        {
                          voucherCode.id
                            ? (
                              <CheckboxField
                                label={ 'Destroy' }
                                color={ 'danger' }
                                id={ `${name}.${index}._destroy` }
                                name={ `${name}.${index}._destroy` }
                              />
                            ) : (
                              <Button
                                size={ 'sm' }
                                outline
                                color='danger'
                                onClick={ () => arrayHelpers.remove(index) }
                              >
                                { 'Remove' }
                              </Button>
                            )
                        }
                      </td>
                    </tr>
                  ))
                }
                {
                  formik.values.vouchers_attributes.length === 0 && (
                    <tr>
                      <td colSpan={ 9 } className='bg-light text-center'>
                        <i className='fas fa-info-circle mr-2' />
                        <span>{ 'No voucher codes' }</span>
                      </td>
                    </tr>
                  )
                }
                <tr>
                  <td colSpan={ 9 } className='text-center'>
                    <Button
                      outline
                      color={ 'default' }
                      onClick={ () => arrayHelpers.push(defaultVoucherAttr) }
                    >
                      { '+ Add Code' }
                    </Button>
                  </td>
                </tr>
              </>
            )
          }
        </FieldArray>
      </tbody>
    </Table>
  )
}

VoucherAttributesFieldArray.propTypes = {
  name: PropTypes.string
}
export default VoucherAttributesFieldArray